import { LoctionStateObject } from "../redux/app/types";
import scrollToElem from "./smoothscroll";
export const statesAvailable = [
  { longName: "Queensland", shortName: "QLD" },
  { longName: "New South Wales", shortName: "NSW" },
  { longName: "South Australia", shortName: "SA" },
  { longName: "Victoria", shortName: "VIC" },
  { longName: "Tasmania", shortName: "TAS" },
  { longName: "Western Australia", shortName: "WA" },
  { longName: "Australian Capital Teritory", shortName: "ACT" },
  { longName: "International", shortName: "INTL" },
] as LoctionStateObject[];
/**
 * Returns state appreviation associated with state name
 *
 * @param {string} longState Long state name
 */
export const toStateObject = (stateString: string, isShortState: boolean) =>
  statesAvailable.find((state) =>
    isShortState
      ? state.shortName === stateString
      : state.longName === stateString
  ) || { longName: "International", shortName: "INTL" };

export const scrollToRef = (ref) =>
  window.scrollTo(0, ref.current.offsetTop + 400);

export const canUseWebP = () => {
  if (typeof window === "undefined") return false;
  const elem = document.createElement("canvas");

  if (!!(elem.getContext && elem.getContext("2d"))) {
    // was able or not to get WebP representation
    return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
  }

  // very old browser like IE 8, canvas not supported
  return false;
};
export const scrollToId = (id) => {

  scrollToElem(id);
  //  const yOffset = -93;
  //const element = window.document.getElementById(id.replace("#",""));
  //  const y = element.offsetTop + yOffset;
  //  window.scrollTo({ top: y, behavior: "smooth" });
};
